const ENDPOINT = 'https://site.api.espn.com/apis/site/v2/sports/football/nfl/scoreboard';
const CACHE_MS = 5 * 60 * 1000;
const cache = new Map();
const pending = new Map();

export const formatOdds = value => {
  if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return '—';
  return Number(value) > 0 ? `+${Number(value)}` : String(Number(value));
};

export function normalizeGames(data) {
  if (!Array.isArray(data.events)) throw new Error('Invalid scoreboard response');
  return data.events.map(event => {
    const competition = event.competitions?.[0];
    const odds = competition?.odds?.[0];
    const team = side => {
      const competitor = competition?.competitors?.find(item => item.homeAway === side);
      return {
        name: competitor?.team?.displayName || 'Team TBD',
        moneyline: formatOdds(odds?.moneyline?.[side]?.close?.odds ?? odds?.[`${side}TeamOdds`]?.moneyLine),
      };
    };
    return {
      id: event.id,
      date: event.date,
      status: competition?.status?.type?.description || event.status?.type?.description,
      home: team('home'),
      away: team('away'),
      spread: odds?.details || '—',
      total: odds?.overUnder ?? '—',
      provider: odds?.provider?.displayName || odds?.provider?.name,
      hasOdds: Boolean(odds),
    };
  }).sort((a, b) => new Date(a.date) - new Date(b.date));
}

export function fetchGameOdds(year, week) {
  const key = `${year}-${week}`;
  const cached = cache.get(key);
  if (cached && Date.now() - cached.fetchedAt < CACHE_MS) return Promise.resolve(cached);
  if (pending.has(key)) return pending.get(key);
  const request = (async () => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(`${ENDPOINT}?dates=${year}&seasontype=2&week=${week}`, {
        signal: controller.signal,
        credentials: 'omit',
      });
      if (!response.ok) throw new Error('Unable to load odds');
      const data = await response.json();
      if (Number(data.season?.year) !== Number(year) || Number(data.season?.type) !== 2 || Number(data.week?.number) !== Number(week)) {
        throw new Error('Scoreboard does not match the selected week');
      }
      const result = { games: normalizeGames(data), fetchedAt: Date.now() };
      cache.set(key, result);
      return result;
    } finally {
      clearTimeout(timeout);
      pending.delete(key);
    }
  })();
  pending.set(key, request);
  return request;
}
